import { JSONContent } from '@tiptap/core';

import { ComponentFillInBlanks } from '../component.constants';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import {
  COLOUR_BLUE,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_ORANGE,
  COLOUR_PURPLE,
  COLOUR_RED,
} from 'approot/shared/colour/colour.constants';
import { InquisitiveActivitiesAnswerType } from 'global/graphql/scalars.type';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<ComponentFillInBlanks, '__typename'>;
export type EditProps = ViewProps;
export type SettingsProps = EditProps & {
  onCloseChildDrawer?: () => void;
};

export type FillInBlanksSentence = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesFillInBlanksResponseComponent' }
  >,
  'properties.fillInBlanks.sentences'
>;
export type FillInBlanksText = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesFillInBlanksResponseComponent' }
  >,
  'properties.fillInBlanks.sentences.textBlocks'
>;
export type FillInBlanksAnswer = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesFillInBlanksResponseComponent' }
  >,
  'properties.fillInBlanks.sentences.answerBlocks'
>;
export type FillInBlanksProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesFillInBlanksResponseComponent' }
  >,
  'properties'
>;

export const COLOURS = [
  COLOUR_GREY,
  COLOUR_BLUE,
  COLOUR_PURPLE,
  COLOUR_GREEN,
  COLOUR_RED,
  COLOUR_ORANGE,
];

export type FillInBlanksResponseAnswer = {
  uuid: string;
  componentId: string;
  activityId: string;
  studentId?: number | null;
  answerType: InquisitiveActivitiesAnswerType | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  answer: {
    answerType: InquisitiveActivitiesAnswerType;
    richtext: JSONContent | null;
  } | null;
  answerReferences: {
    id?: string | null;
  } | null;
};

export const BASE_FILL_IN_BLANKS_RICHTEXT_SETTINGS = {
  placeholder: '',
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: false,
  canChangeHistory: true,
  preventNewLine: true,
};

export const BASE_FILL_IN_BLANKS_TEXT_BLOCK_SETTINGS = {
  placeholder: '',
  canBold: false,
  canItalic: false,
  canUnderline: false,
  canAddLists: false,
  canChangeHistory: false,
  preventNewLine: true,
};
